module.exports = __webpack_public_path__ + "static/basiseinkommen-6855f318eb0d2f07cc1ad0b6b66714a7.mp4";